<script lang="ts" setup>
// Scoped styles on SVGs were breaking our HTML Validator, so icons were moved to separate components
// and wrapped in <span> tags. This prevented scoped styles from breaking the parser.
import ChevronRightIcon from '~icons/mdi/chevron-right';
</script>

<template>
  <span>
    <ChevronRightIcon />
  </span>
</template>
